var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 13.5C16.6897 13.5 21.1667 7.5 21.1667 7.5C21.1667 7.5 16.6897 1.5 11.1667 1.5C5.64366 1.5 1.16666 7.5 1.16666 7.5C1.16666 7.5 5.64366 13.5 11.1667 13.5Z",
    stroke: "#4D4D4D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 10C11.8297 10 12.4656 9.73661 12.9344 9.26777C13.4033 8.79893 13.6667 8.16304 13.6667 7.5C13.6667 6.83696 13.4033 6.20107 12.9344 5.73223C12.4656 5.26339 11.8297 5 11.1667 5C10.5036 5 9.86774 5.26339 9.3989 5.73223C8.93006 6.20107 8.66666 6.83696 8.66666 7.5C8.66666 8.16304 8.93006 8.79893 9.3989 9.26777C9.86774 9.73661 10.5036 10 11.1667 10Z",
    stroke: "#4D4D4D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDisabled);
export default __webpack_public_path__ + "static/media/eye_disabled.7d4bd055b90dda174c65f9cbcb09d30e.svg";
export { ForwardRef as ReactComponent };